module.exports = __webpack_public_path__ + "static/profile-pic-daf5eaf55b1c992fa9a78a1d0d1c919e.jpg";